import { Card, Input, Select, Skeleton, Tooltip } from "antd";
import { HelpCircle } from "lucide-react";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Icon from "../../../assets/Icon";
import MockGuideListPage from "./MockGuideListPage";
import NoCreditModal from "../preparation/NoCreditModal";

function MockInterviewGuide({ moduleInfo }) {
  const [guideDataFlag, setGuideDataFlag] = useState(null);
  const [clearResultsFlag, setClearResultsFlag] = useState(false);
  const [notFoundFlag, setNotFoundFlag] = useState(false);
  const [mockGuideStatus, setMockGuideStatus] = useState("ALL");
  const [searchText, setSearchText] = useState("");
  const [searchButtonText, setSearchButtonText] = useState("");
  const [jobGuideFilters, setJobGuideFilters] = useState(
    "SORT_BY_CREATION_DATE"
  );

  const [loading, setLoading] = useState(false);
  const [creditModalFlag, setCreditModalFlag] = useState(false);

  const [guideData, setGuideData] = useState(null);

  const handleStatusChange = (value) => {
    setMockGuideStatus(value);
  };
  const handleSortChange = (value) => {
    setJobGuideFilters(value);
  };
  const handleSearch = () => {
    setClearResultsFlag(false);
    setSearchButtonText(searchText);
  };
  const handleClearSearch = () => {
    setClearResultsFlag(true);
    setSearchText("");
    setSearchButtonText("");
  };

  return (
    <>
      {creditModalFlag && (
        <NoCreditModal
          creditModalFlag={creditModalFlag}
          setCreditModalFlag={setCreditModalFlag}
        />
      )}
      <div className="md:px-8 sm:px-6 px-4 mt-3">
        <div className="w-full flex justify-between flex-col lg:flex-row gap-4 ">
          <div className="flex-1 mt-[1rem] flex flex-wrap gap-2 driver-all-guide-search">
            <Input
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="w-[300px] px-2 py-[0.36rem] border border-[#D0D5DD] shadow-sm"
              prefix={<Icon type="search-icon" />}
              // size="large"
              placeholder="Search"
              onPressEnter={handleSearch}
            />
            <div className="flex gap-2">
              <button
                className="w-[105px] btn-orange py-[0.35rem] px-[1rem] text-[.9rem]"
                onClick={handleSearch}
              >
                Search
              </button>
              {searchButtonText && (
                <button
                  className="w-[135px] btn-white py-[0.35rem] px-[1rem] text-[.9rem]"
                  onClick={handleClearSearch}
                >
                  Clear Results
                </button>
              )}
            </div>
            <div className="flex items-start gap-3 flex-wrap">
              <Select
                className="driverjs-all-guide-status-filter"
                defaultValue="All"
                suffixIcon=<svg
                  width="15"
                  height="15"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 10H15M2.5 5H17.5M7.5 15H12.5"
                    stroke="#344054"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                style={{
                  width: 140,
                }}
                onChange={handleStatusChange}
                options={[
                  {
                    value: "ALL",
                    label: "All",
                  },
                  {
                    value: "CONFIGURED",
                    label: "Configured",
                  },
                  {
                    value: "INTERVIEW_SCHEDULED",
                    label: "Interview Scheduled",
                  },
                  {
                    value: "INTERVIEW_COMPLETED",
                    label: "Interview Completed",
                  },
                  {
                    value: "INTERVIEW_EXPIRED",
                    label: "Interview Expired",
                  },
                ]}
              />
              <Select
                className="driverjs-all-guide-date-filer"
                defaultValue="SORT_BY_CREATION_DATE"
                suffixIcon=<svg
                  width="15"
                  height="15"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 10H15M2.5 5H17.5M7.5 15H12.5"
                    stroke="#344054"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                style={{
                  width: 150,
                }}
                onChange={handleSortChange}
                options={[
                  {
                    value: "SORT_BY_CREATION_DATE",
                    label: "Sort by date",
                  },
                  {
                    value: "SORT_BY_COMPANY_NAME",
                    label: "Sort by company",
                  },
                  {
                    value: "SORT_BY_JOB",
                    label: "Sort by job",
                  },
                ]}
              />
              {moduleInfo?.mockInterviewCredits > 0 ? (
                <Link to="/mock-interview-create-jd" className="">
                  <button className="btn-orange py-[0.35rem] px-[0.9rem] text-[.9rem]">
                    + Create new
                  </button>
                </Link>
              ) : (
                <button
                  onClick={() => setCreditModalFlag(true)}
                  className="btn-orange py-[.35rem] px-[0.9rem] text-[.9rem]"
                >
                  + Create new
                </button>
              )}
            </div>
          </div>
          <div className="w-fit flex justify-end items-center gap-y-2 gap-x-3">
            <div className="flex gap-1 items-center justify-center text-[.83rem] font-semibold border border-[#FEC84B] bg-[#FFFAEB] text-[#0F1B23] rounded-full hover-effect px-3 py-[.2rem]">
              Interview Credits:{" "}
              {moduleInfo?.mockInterviewCredits > 0 ? (
                <span className="text-green-600 font-mono text-[.98rem] font-semibold">
                  {moduleInfo?.mockInterviewCredits}
                </span>
              ) : (
                <span className="text-red-500 font-mono text-[1rem] font-semibold">
                  {moduleInfo?.mockInterviewCredits}
                </span>
              )}
              <Tooltip
                title={
                  <>
                    <div className="font-medium text-center text-[.88rem] text-orangish">
                      Credits Left:{" "}
                      <span className="font-bold ">
                        {moduleInfo?.mockInterviewCredits}
                      </span>
                    </div>
                    <div className="text-white text-center">
                      This shows the number of credits you have left to create
                      Mock Interviews.
                    </div>
                  </>
                }
                overlayInnerStyle={{
                  padding: "10px 14px",
                  background: "#0F1B23",
                }}
              >
                <HelpCircle size={19} className="ml-1 cursor-pointer" />
              </Tooltip>
            </div>
            <Link to={"/credits"}>
              <button className="py-[.35rem] px-[.9rem] text-[.9rem] btn-orange">
                Buy Credits
              </button>
            </Link>
          </div>
        </div>

        <div>
          <MockGuideListPage
            setGuideData={setGuideData}
            guideData={guideData}
            setMockGuideStatus={setMockGuideStatus}
            mockGuideStatus={mockGuideStatus}
            setJobGuideFilters={setJobGuideFilters}
            jobGuideFilters={jobGuideFilters}
            searchButtonText={searchButtonText}
            setNotFoundFlag={setNotFoundFlag}
            notFoundFlag={notFoundFlag}
            moduleInfo={moduleInfo}
          />
        </div>
      </div>
    </>
  );
}

export default MockInterviewGuide;
